
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

export default {
name: 'tabWrap',
props:{
tabList:{
type: Array
},
active: {
type: String,
default: '0'
}
},
components:{
Tab,
TabItem,
},
data(){
return{
activeindex: this.active
}
},
methods:{
changeTabIndex(index,item){
this.$emit('changeData',index,item)
}
},
}
